import type {
  TurnstileRuntimeLogLevel,
  TurnstileRuntimeOptions,
} from './types'

export const emitRuntimeEvent = (
  options: TurnstileRuntimeOptions | undefined,
  level: TurnstileRuntimeLogLevel,
  event: string,
  context?: Record<string, unknown>,
) => {
  options?.onEvent?.({ level, event, context })
}
